// ============================================
// FIRMADEDO.JS — firma con el dedo en el celular (ALMACEN v3, 2026-10-21)
// ============================================
// Lienzo tactil (pointer events: dedo, mouse o stylus) que entrega la firma como PNG en data URL.
// Lo usan la SALIDA DE MATERIAL (firma de quien recibe, A5) y el ACTA DE ENTREGA al cliente (B8).
// Props: onChange(dataUrl|null), alto (px, default 180), etiqueta.
// El lienzo se dibuja al tamano real del elemento (devicePixelRatio) para que la firma no salga pixelada.
import React, { useEffect, useRef, useState } from 'react';

const PP = "'Poppins', sans-serif";

export default function FirmaDedo({ onChange, alto = 180, etiqueta = 'Firma de quien recibe' }) {
  const canvasRef = useRef(null);
  const dibujando = useRef(false);
  const ultimo = useRef(null);
  const [tieneTrazo, setTieneTrazo] = useState(false);
  const trazoRef = useRef(false); // (tribunal) un toque sin trazo NO es firma: no se emite nada

  useEffect(() => {
    const c = canvasRef.current;
    if (!c) return;
    const dpr = window.devicePixelRatio || 1;
    const rect = c.getBoundingClientRect();
    c.width = Math.max(1, Math.round(rect.width * dpr));
    c.height = Math.max(1, Math.round(rect.height * dpr));
    const ctx = c.getContext('2d');
    ctx.scale(dpr, dpr);
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, rect.width, rect.height);
    ctx.lineWidth = 2.5;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.strokeStyle = '#1f2d3d';
  }, []);

  const punto = (e) => {
    const c = canvasRef.current;
    const r = c.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  };
  const empezar = (e) => {
    e.preventDefault();
    dibujando.current = true;
    ultimo.current = punto(e);
    try { e.currentTarget.setPointerCapture(e.pointerId); } catch { /* sin captura */ }
  };
  const mover = (e) => {
    if (!dibujando.current) return;
    e.preventDefault();
    const p = punto(e);
    const ctx = canvasRef.current.getContext('2d');
    ctx.beginPath();
    ctx.moveTo(ultimo.current.x, ultimo.current.y);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    ultimo.current = p;
    trazoRef.current = true;
    if (!tieneTrazo) setTieneTrazo(true);
  };
  const terminar = () => {
    if (!dibujando.current) return;
    dibujando.current = false;
    if (onChange && trazoRef.current) onChange(canvasRef.current.toDataURL('image/png'));
  };
  const limpiar = () => {
    const c = canvasRef.current;
    const ctx = c.getContext('2d');
    const r = c.getBoundingClientRect();
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, r.width, r.height);
    setTieneTrazo(false);
    trazoRef.current = false;
    if (onChange) onChange(null);
  };

  return (
    <div style={{ fontFamily: PP }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
        <span style={{ fontSize: 11, color: '#8a8f95', fontWeight: 700, textTransform: 'uppercase' }}>✍️ {etiqueta}</span>
        <button type="button" onClick={limpiar} style={{ background: 'transparent', border: 'none', color: '#2f5f9e', fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: PP, minHeight: 32 }}>Borrar</button>
      </div>
      <canvas
        ref={canvasRef}
        data-firma="lienzo"
        onPointerDown={empezar}
        onPointerMove={mover}
        onPointerUp={terminar}
        onPointerCancel={terminar}
        onPointerLeave={terminar}
        style={{ width: '100%', height: alto, border: `2px dashed ${tieneTrazo ? '#1D9E75' : '#c9d0d8'}`, borderRadius: 12, background: '#fff', touchAction: 'none', display: 'block', boxSizing: 'border-box' }}
      />
      <div style={{ fontSize: 11, color: '#8a8f95', marginTop: 4 }}>{tieneTrazo ? 'Firma capturada.' : 'Firma con el dedo dentro del recuadro.'}</div>
    </div>
  );
}
